import { EventEmitter } from '@angular/core';
import { Action } from '@ngrx/store';

export const REQUEST_FILE_UPLOAD_CANCEL = '[FileUpload][Request] Cancel Upload';
export const REQUEST_FILE_UPLOAD_START = '[FileUpload][Request] Start Upload';
export const RESPONSE_FILE_UPLOAD_CANCEL = '[FileUpload][Response] Cancel Upload';
export const RESPONSE_FILE_UPLOAD_COMPLETE = '[FileUpload][Response] Upload Complete';
export const RESPONSE_FILE_UPLOAD_ERROR = '[FileUpload][Response] Upload Error';
export const RESPONSE_FILE_UPLOAD_PROGRESS = '[FileUpload][Response] Upload Progress';
export const RESPONSE_FILE_UPLOAD_START = '[FileUpload][Response] Start Upload';

export class RequestFileUploadStartAction implements Action {
  readonly type = REQUEST_FILE_UPLOAD_START;
  constructor(public payload: { id: string; file: File; url?: string; type?: string }) {}
}

export class ResponseFileUploadStartedAction implements Action {
  readonly type = RESPONSE_FILE_UPLOAD_START;
  constructor(public payload: { id: string }) {}
}

export class RequestFileUploadCancelAction implements Action {
  readonly type = REQUEST_FILE_UPLOAD_CANCEL;
  constructor(public payload: { id: string }) {}
}

export class ResponseFileUploadCancelAction implements Action {
  readonly type = RESPONSE_FILE_UPLOAD_CANCEL;
  constructor(public payload: { id: string }) {}
}

export class ResponseFileUploadProgressAction implements Action {
  readonly type = RESPONSE_FILE_UPLOAD_PROGRESS;
  constructor(public payload: { id: string; progress: number }) {}
}

export class ResponseFileUploadCompleteAction implements Action {
  readonly type = RESPONSE_FILE_UPLOAD_COMPLETE;
  constructor(public payload: { id: string; response: any; type?: string }) {}
}

export class ResponseFileUploadErrorAction implements Action {
  readonly type = RESPONSE_FILE_UPLOAD_ERROR;
  constructor(public payload: { id: string; error: any }) {}
}
